import React from 'react';
import WebComponentsConfig from '../components/WebComponentsConfig';

import png403 from '../images/403.png';
import background from '../images/background.png';

import { 
    OmErrorPage,
    OmWizardHeader,
    OmErrorIllustrationControl
} from '@om/component-library-react';

const ErrorPage = () => (
    <WebComponentsConfig>
        <OmErrorPage>
            <OmWizardHeader slot="header" />
            <OmErrorIllustrationControl
                slot="error-illustration-control"
                buttonUrl="/"
                buttonText="GO TO HOME"
                backgroundImage={background}
                errorImage={png403}
            >
                <h4 slot="main-text">
                    Oops! This is awkward.
                </h4>
                <span slot="sub-text">You do not have permission to access this resource.</span>
            </OmErrorIllustrationControl>
        </OmErrorPage>
    </WebComponentsConfig>
);

export default ErrorPage;
